import { configureStore, AnyAction } from '@reduxjs/toolkit';
import {
  connectRouter,
  RouterState,
  routerMiddleware,
} from 'connected-react-router';
import history from './history';
import { Reducer } from 'react';
import appSlice from '../features/App/App.slice';
import allEventsSlice from '../features/AllEvents/AllEvents.slice';
import createSagaMiddleware from 'redux-saga';
// import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    // prettier-ignore
    router: connectRouter(history) as Reducer<RouterState | undefined, AnyAction>,
    app: appSlice,
    allEvents: allEventsSlice,
  },
  middleware: [routerMiddleware(history), sagaMiddleware],
  devTools: process.env.NODE_ENV !== 'production',
});

// sagaMiddleware.run(rootSaga);

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
